<template>
  <custom-autocomp-grouped-select
    ref="innerComp"
    v-model="_value"
    :options="get_product"
    :placeholder="_value"
    @searchchange="load_product"
    :debounce="1000"
    :skip-input-when-actionable="skipInputWhenActionable"
  ></custom-autocomp-grouped-select>
</template>

<script>
import CustomAutocompGroupedSelect from '../../Lib/CustomAutocompGroupedSelect'

export default {
  components: {
    CustomAutocompGroupedSelect,
  },
  props: {
    value: { type: String, default: '' },
    // Opt-in — see CustomAutocompGroupedSelect's own prop doc. Defaults to false: picking a
    // product/sid then commits the picked name as the applied search text, alongside navigating
    // to the product page.
    skipInputWhenActionable: { type: Boolean, default: false },
  },
  data() {
    return {
      autoCompleteResponse: null,
      requestSeq: 0,
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('input', newVal)
      },
    },
    get_product: function () {
      if (this.autoCompleteResponse == null) {
        return {}
      }
      return {
        issuers: {
          options: this.autoCompleteResponse.issuers.map((el) => {
            return {
              text: el.issuerName || '',
              value: el,
            }
          }),
          label: '<i class="fas fa-university"></i> ' + this.$t('common.issuers'),
        },
        products: {
          options: this.autoCompleteResponse.products.map((el) => {
            return {
              text:
                el.name +
                (this.isProductUnderTesting(el)
                  ? ' - ' + this.$t('pit.productUnderTesting')
                  : ' - ' + (el.issuerName || '')),
              value: el,
              onClick: (item) => this.openProductDetails(item, null, true),
            }
          }),
          label: '<i class="fas fa-cube"></i> ' + this.$t('common.products'),
        },
        sids: {
          options: this.autoCompleteResponse.sids.map((el) => {
            return {
              text:
                el.investmentOptionName +
                ' - ' +
                el.name +
                (this.isProductUnderTesting(el)
                  ? ' - ' + this.$t('pit.productUnderTesting')
                  : ' - ' + (el.issuerName || '')) +
                (el.investmentOptionIsin ? ' - ' + el.investmentOptionIsin : ''),
              value: el,
              onClick: (item) => this.openProductDetails(item, null, true),
            }
          }),
          label: '<i class="fas fa-money-check"></i> ' + this.$t('search.label.investmentOptions'),
        },
      }
    },
  },
  methods: {
    clearInput() {
      this.$refs.innerComp.clearInput()
    },
    load_product(searchText) {
      // Typing a burst, pausing >1s (debounce), then typing again fires a new request while a
      // previous, slower one may still be in flight. Without sequencing, whichever response lands
      // LAST wins — even if it's the older query — showing stale results for the current text.
      const seq = ++this.requestSeq
      this.get('/api/searchfilters/autocomplete', { S: searchText })
        .then((resp) => {
          if (seq === this.requestSeq) {
            this.autoCompleteResponse = resp
          }
        })
        .catch(() => {
          if (seq === this.requestSeq) {
            this.autoCompleteResponse = {}
          }
        })
    },
    isProductUnderTesting(element) {
      return element.issuerCode === 'PIT' || false
    },
  },
}
</script>
